import React, {CSSProperties, Dispatch, SetStateAction, useState} from 'react';
import 'react-mde/lib/styles/css/react-mde-all.css';
import { ChangelogArticle } from '@lfp-digital/back-types-mpg';
import { ArticleEditorContent } from './Content';
import { ArticleEditorMetaData } from './MetaData';
import { SubMenu } from '../../../components/SubMenu';

const styles: Record<string, CSSProperties> = {
  container: {
    marginTop: 16,
  },
  content: {
    paddingLeft: 8,
    paddingRight: 8,
    paddingTop: 16,
    paddingBottom: 16,
    width: '100%',
    backgroundColor: 'white',
  },
};


export type ArticleEditorProps = {
  onChange: (key: string, value: any) => void;
  data: Partial<ChangelogArticle>;
  versions: string[] | undefined;
  version: string | undefined;
  setVersion: Dispatch<SetStateAction<string | undefined>>;
  isCreation?: boolean;
  isMPP?: boolean;
};

export const ArticleEditor = ({data, onChange, version, setVersion, versions, isCreation, isMPP}: ArticleEditorProps) => {
  const [selectedTabs, setSelectedTabs] = useState<number>(0);
  const onChangeMenuIndex = (index: number) => setSelectedTabs(index);

  const tabs = [
    {
      label: 'Meta données',
      isRequired: true,
      ContentComponent: ArticleEditorMetaData,
    },
    {
      label: 'Contenu post',
      isRequired: !isCreation,
      ContentComponent: ArticleEditorContent,
    },
  ];

  const ContentComponent = tabs[selectedTabs].ContentComponent;

  return (
    <div style={styles.container}>
      <SubMenu
        tabs={tabs}
        selectedTabs={selectedTabs}
        onChange={onChangeMenuIndex}
      />
       <div style={styles.content}>
        <ContentComponent
          data={data}
          onChange={onChange}
          setVersion={setVersion}
          version={version}
          versions={versions}
          isCreation={isCreation}
          isMPP={isMPP}
        />
      </div>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/pages/Articles/Editor/index.tsx